import { Injectable } from '@angular/core';
import { OrganizationService } from '@boma/client-shared';
import {
  IProfileEntity,
  IProfileEntityDetail,
} from '@boma/supplier-portal/shared/entities';
import { AuthedUserService } from '@boma/supplier-portal/shared/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { fetch } from '@nx/angular';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as UserActions from './user.actions';

@Injectable()
export class UserEffects {
  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUser),
      withLatestFrom(this.store),
      fetch({
        run: (action, state: any) => {
          return this.userService.loadUser().pipe(
            switchMap((response) => {
              let localEntityAccess = false;
              response.entities.map((e) => {
                if (
                  !localEntityAccess &&
                  e.id === localStorage.getItem('selectedEntityId')
                ) {
                  localEntityAccess = true;
                }
              });
              const chosenEntityId = localEntityAccess
                ? localStorage.getItem('selectedEntityId')
                : response.entities[0].id;
              localStorage.selectedEntityId = chosenEntityId;
              const chosenEntity = response.entities.find(
                (x) => x.id === chosenEntityId
              );
              if ((chosenEntity as any)?.registeredName) {
                response.entities = response.entities.map((e) =>
                  e.id === chosenEntity.id
                    ? new IProfileEntityDetail(chosenEntity, e)
                    : new IProfileEntity(e)
                );
                return of(UserActions.loadUserSuccess({ payload: response }));
              } else {
                return this.organisationService
                  .loadOrganizationDetails(chosenEntityId)
                  .pipe(
                    map((entityResponse) => {
                      response.entities = response.entities.map((e) =>
                        e.id === entityResponse.id
                          ? new IProfileEntityDetail(entityResponse, e)
                          : new IProfileEntity(e)
                      );
                      return UserActions.loadUserSuccess({ payload: response });
                    })
                  );
              }
            })
          );
        },
        onError: (action, error) => {
          console.error('Error', error);
          return UserActions.loadUserFailure({ error });
        },
      })
    )
  );
  loadEntity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.getEntityDetails),
      fetch({
        run: (action) => {
          return this.organisationService
            .loadOrganizationDetails(action.id)
            .pipe(
              map((response) =>
                UserActions.loadEntitySuccess({ payload: response })
              )
            );
        },
      })
    )
  );

  constructor(
    private actions$: Actions,
    private userService: AuthedUserService,
    private organisationService: OrganizationService,
    private store: Store
  ) {}
}
